import { render, staticRenderFns } from "./DeviceLocationLink.vue?vue&type=template&id=5624340f"
import script from "./DeviceLocationLink.vue?vue&type=script&lang=ts"
export * from "./DeviceLocationLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports